// Deep merge two objects, with preference for non-empty values in target. Single source for the
// inboedel/woonhuis/aansprakelijkheid calc chains (each calc.ts re-exports it, so barrels and
// tests keep importing from './calc'). This is the array-safe inboedel variant.
export const deepMerge = (target: any, source: any): any => {
  if (!source || typeof source !== 'object') {
    return target;
  }
  if (!target || typeof target !== 'object') {
    return source;
  }

  const result = { ...target };

  for (const key in source) {
    if (target[key] === undefined || target[key] === null || target[key] === '') {
      result[key] = source[key];
    } else if (Array.isArray(target[key]) || Array.isArray(source[key])) {
      // Never object-spread an array (it corrupts to {"0": ...}); target wins,
      // matching the function's prefer-non-empty-target semantics.
      result[key] = target[key];
    } else if (typeof target[key] === 'object' && typeof source[key] === 'object') {
      result[key] = deepMerge(target[key], source[key]);
    }
  }

  return result;
};
